import { isEmpty } from './utilities';

export default class GlossaryDialog {
	constructor() {
		// Listen clicks to the open buttons
		this.handleOpen();
	}

	/**
	 * Handle the open event of the dialog
	 */
	handleOpen() {
		this.$openButtons.forEach( ( $openButton ) => {
			// Get the group ID
			const groupID = $openButton.dataset.glossary;

			// Listen clicks
			$openButton.addEventListener( 'click', ( event ) => {
				// Prevent default behavior
				event.preventDefault();

				// Open the dialog
				this.openDialog( groupID );
			} );
		} );
	}

	/**
	 * Open dialog
	 *
	 * @param {String} groupID The ID of the selected group
	 */
	openDialog( groupID = '' ) {
		// Check if there is a valid group ID
		if ( isEmpty( groupID ) ) {
			// Get the group ID of the first group
			try {
				groupID = this.$firstDialogGroup.dataset.id;
			} catch ( e ) {
				console.warn( e );
			}
		}

		// Display the dialog
		this.$dialog.style.display = 'block';

		// Fade in
		setTimeout( () => {
			this.$dialog.classList.add( 'automator-footer-dialog--show' );
		}, 1 );

		// Disable scrolling of body element
		document.body.classList.add( 'automator-footer-body-disable-scroll' );

		// Try to scroll to the selected group
		try { 
			// Get the element selected group
			const $selectedGroup = this.$dialog.querySelector( `.automator-footer-dialog-group[data-id="${ groupID }"]` );

			// Scroll to the selected group
			$selectedGroup.scrollIntoView( {
				behavior: 'smooth',
				block: 'start',
			} );
		} catch ( e ) {
			console.warn( e );
		}			

		// Close method
		const closeDialog = () => {
			// Fade out
			this.$dialog.classList.remove( 'automator-footer-dialog--show' );

			// Wait for fade out
			// The duration (150ms) is defined in the CSS
			setTimeout( () => {
				// Close dialog
				this.$dialog.style.display = 'none';
				
				// Enable scrolling of body element
				document.body.classList.remove( 'automator-footer-body-disable-scroll' );

				// Remove event listeners
				this.$dialog.removeEventListener( 'click', listenClose );
				document.removeEventListener( 'keydown', listenEscKey );
				this.$closeButton.removeEventListener( 'click', listenCloseButton );
			}, 150 );
		}

		// Add event listener to listen clicks outside the dialog
		const listenClose = ( event ) => {
			// Check if it's clicking outside the dialog box
			if ( ! this.$dialogBox.contains( event.target ) ) {
				closeDialog();
			} 
		};

		this.$dialog.addEventListener( 'click', listenClose );

		// Listen Esc key
		const listenEscKey = ( event ) => {
			// Check if the user is pressing the "Escape" key
			if ( event.key === 'Escape' ) {
				// Close dialog
				closeDialog();
			}
		}

		document.addEventListener( 'keydown', listenEscKey );

		// Listen clicks to the close button
		const listenCloseButton = () => {
			// Close dialog
			closeDialog();
		}

		this.$closeButton.addEventListener( 'click', listenCloseButton );
	}

	/**
	 * Returns all the buttons that open the dialog
	 * @return {NodeList} The buttons
	 */
	get $openButtons() {
		return document.querySelectorAll( '.automator-footer-glossary-letter, .automator-footer-glossary-open-generic' );
	}

	/**
	 * Returns the node of the dialog
	 * @return {Node} The dialog
	 */
	get $dialog() {
		return document.getElementById( 'automator-footer-dialog' );
	}

	/**
	 * Returns the node of the dialog box
	 * @return {Node} The dialog box
	 */
	get $dialogBox() {
		return document.querySelector( '.automator-footer-dialog-box' );
	}

	/**
	 * Returns the node of the first dialog group
	 * @return {Node} The first dialog group
	 */
	get $firstDialogGroup() {
		return document.querySelector( '.automator-footer-dialog-group:first-child' );
	}

	/**
	 * Returns the node of the close button
	 * 
	 * @return {Node} The close button
	 */
	get $closeButton() {
		return document.getElementById( 'automator-footer-dialog-close' );
	}
}
